
import { Component, Vue, Prop } from 'vue-property-decorator';


@Component
export default class ClockEndCircle extends Vue {

    @Prop({required: false})
    active!: boolean;

    @Prop({required: false})
    className!: string;

    @Prop({required: false})
    stepTitle!: string;

    @Prop({required: false})
    titleStyle!: string;

    @Prop({required: false})
    completed!: boolean;

    public action(){
        this.$emit('action')
    }

    mounted(){
        
    }

}
